import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

import Column from "../../../common/components/Column"

export default function AdminZohoMailboxDeleteDialog({
  open,
  mailbox,
  onClose,
  onConfirm,
  saving,
  errorMessage,
}) {
  const email = mailbox?.email || "this mailbox"

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Zoho mailbox</DialogTitle>
      <DialogContent>
        <Column gap={2}>
          <Typography variant="body2">
            Disable <strong>{email}</strong> in your Zoho Mail organization and
            disconnect it in OneBase for{" "}
            {mailbox?.assigned_user_name ||
              mailbox?.assigned_user_email ||
              "this concierge"}
            ?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This uses Zoho&apos;s disable-user API (same as concierge Settings →
            disconnect). The mailbox row stays in OneBase as disabled for audit
            history. OAuth tokens on this row are cleared.
          </Typography>
          {errorMessage ? (
            <Typography color="error" variant="body2">
              {errorMessage}
            </Typography>
          ) : null}
        </Column>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={saving}
          onClick={() => onConfirm()}
        >
          Delete mailbox
        </Button>
      </DialogActions>
    </Dialog>
  )
}

AdminZohoMailboxDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  mailbox: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  errorMessage: PropTypes.string,
}
